import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@mui/material";
import { getI18n, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import { useAuth } from "../context/useAuth";

function Footer({ open, drawerWidth }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userInfo, authenticated } = useAuth();

  const hasPhone = authenticated && !!userInfo["coChamberPhones"];
  const hasEmail = authenticated && !!userInfo["coChamberEmail"];
  const hasDescr =
    authenticated &&
    (!!userInfo["coChamberDescr"] || !!userInfo["coChamberDescrEn"]);

  const hasContactInfo = hasPhone || hasEmail || hasDescr;

  const privacySection = [
    {
      label: t("Πολιτική Cookies"),
      onClick: () => {
        navigate("/welcome/cookies");
      },
    },
    {
      label: t("Πολιτική Απορρήτου"),
      onClick: () => {
        navigate("/welcome/privacyPolicies");
      },
    },
  ];

  const contactSection = authenticated
    ? [
        {
          title: (
            <LocalPhoneIcon sx={{ color: "#4295ce", width: 20, height: 20 }} />
          ),
          label: userInfo["coChamberPhones"] ? (
            <Link
              color={"inherit"}
              href={`tel: 30${authenticated && userInfo["coChamberPhones"] ? userInfo["coChamberPhones"] : "210 3387104"}`}
              underline="none"
              sx={{ "&:hover": { textDecoration: "underline" } }}
            >
              {userInfo["coChamberPhones"]}
            </Link>
          ) : (
            ""
          ),
        },
        {
          title: <EmailIcon sx={{ color: "white", width: 20, height: 20 }} />,
          label: userInfo["coChamberEmail"] ? (
            <Link
              color="inherit"
              href={`mailto:${authenticated && userInfo["coChamberEmail"] ? userInfo["coChamberEmail"] : "info@uhc.gr"}`}
              underline="none"
              sx={{ "&:hover": { textDecoration: "underline" } }}
            >
              {userInfo["coChamberEmail"]}
            </Link>
          ) : (
            ""
          ),
        },
      ]
    : [];

  return (
    <Box
      sx={{
        display: "flex",
        background: "#2F4858",
        minHeight: "30vh",
        flexDirection: "column",
        width: "100%",
        p: 0,
        justifyContent: "start",
        color: "white",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ p: 2, width: "100%", justifySelf: "start" }}
      >
        <Grid container spacing={4} sx={{ display: "flex", width: "100%" }}>
          <Grid item xs={12} md={9}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={5}>
                <Typography variant="h6" gutterBottom>
                  {t("Πληροφορίες & Απόρρητο")}
                </Typography>
                <List>
                  {privacySection.map((item, idx) => (
                    <ListItem key={idx} disablePadding>
                      <Button
                        onClick={item.onClick}
                        color="inherit"
                        sx={{
                          textWrap: "wrap",
                          "&:hover": {
                            backgroundColor: "transparent",
                            textDecoration: "underline",
                          },
                        }}
                      >
                        <ListItemText primary={item.label} />
                      </Button>
                    </ListItem>
                  ))}
                </List>
              </Grid>
              {hasContactInfo && (
                <Grid item xs={12} sm={3}>
                  <Typography variant="h6" gutterBottom>
                    {t("Επικοινωνία")}
                  </Typography>
                  <List>
                    <>
                      {hasDescr && (
                        <ListItem
                          disablePadding
                          sx={{
                            display: "flex",
                            justifyContent: "start",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography>{t("Αρμόδια Υπηρεσία ΓΕΜΗ")}:</Typography>
                          <Typography variant="subtitle2">
                            {getI18n().language == "el"
                              ? userInfo["coChamberDescr"]
                              : userInfo["coChamberDescrEn"]}
                          </Typography>
                        </ListItem>
                      )}
                      {hasPhone && (
                        <ListItem
                          disablePadding
                          sx={{
                            display: "flex",
                            gap: ".5rem",
                            justifyContent: "start",
                            lineHeight: 2,
                          }}
                        >
                          <LocalPhoneIcon
                            sx={{ color: "#4295ce", width: 20, height: 20 }}
                          />
                          <Link
                            color="inherit"
                            href={`tel:30${userInfo["coChamberPhones"]}`}
                            underline="none"
                            sx={{ "&:hover": { textDecoration: "underline" } }}
                          >
                            {userInfo["coChamberPhones"]}
                          </Link>
                        </ListItem>
                      )}
                      {hasEmail && (
                        <ListItem
                          disablePadding
                          sx={{
                            display: "flex",
                            gap: ".5rem",
                            justifyContent: "start",
                            lineHeight: 2,
                          }}
                        >
                          <EmailIcon
                            sx={{ color: "white", width: 20, height: 20 }}
                          />
                          <Link
                            color="inherit"
                            href={`mailto:${userInfo["coChamberEmail"]}`}
                            underline="none"
                            sx={{ "&:hover": { textDecoration: "underline" } }}
                          >
                            {userInfo["coChamberEmail"]}
                          </Link>
                        </ListItem>
                      )}
                    </>
                  </List>
                </Grid>
              )}
              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  {t("Τραπεζικές Πληρωμές")}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        background: "white",
                        width: 40,
                        height: 30,
                      }}
                      src="/images/VISA2.jpg"
                      alt="card"
                    />
                    <Box
                      component="img"
                      sx={{
                        background: "white",
                        width: 50,
                        height: 30,
                      }}
                      src="/images/MasterCard-Logo.svg.png"
                      alt="card"
                    />
                    <Box
                      component="img"
                      sx={{
                        background: "white",
                        width: 50,
                        height: 30,
                      }}
                      src="/images/NicePng_mastercard-png_1367187.png"
                      alt="card"
                    />
                  </Box>
                  <Box>
                    <IconButton
                      color="inherit"
                      onClick={() =>
                        window.open(
                          `${window.location.origin}/welcome/visaMore`,
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      <Box
                        sx={{
                          position: "relative",
                          width: 55,
                          height: 45,
                          background: "white",
                        }}
                      >
                        <Box
                          component="img"
                          src="/images/verified-by-visa6450.jpg"
                          alt="card"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            position: "absolute",
                            bottom: 1,
                            left: "50%",
                            transform: "translateX(-50%)",
                            color: "blue",
                            fontWeight: "bold",
                            textDecoration: "underline",
                            whiteSpace: "nowrap",
                            fontSize: "0.5rem",
                          }}
                        >
                          learn more
                        </Typography>
                      </Box>
                    </IconButton>

                    <IconButton
                      color="inherit"
                      sx={{ py: 1 }}
                      onClick={() =>
                        window.open(
                          `${window.location.origin}/welcome/mcMore`,
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      <Box
                        sx={{
                          position: "relative",
                          width: 65,
                          height: 45,
                          background: "white",
                        }}
                      >
                        <Box
                          component="img"
                          src="/images/mastercard-securecode.webp"
                          alt="card"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            position: "absolute",
                            bottom: 1,
                            left: "50%",
                            transform: "translateX(-50%)",
                            color: "blue",
                            fontWeight: "bold",
                            textDecoration: "underline",
                            whiteSpace: "nowrap",
                            fontSize: "0.5rem",
                          }}
                        >
                          learn more
                        </Typography>
                      </Box>
                    </IconButton>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3} justifySelf={"end"} sx={{}}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems={"center"}
              gap={2}
              textAlign={"start"}
            >
              <Box
                component="img"
                src="/images/favicon.svg?height=100&width=100"
                sx={{ width: 150, height: 150 }}
              />
              <Button
                variant="text"
                color="inherit"
                onClick={() => {
                  window.open(
                    "https://www.uhc.gr/",
                    "_blank",
                    "noopener,noreferrer",
                  );
                }}
                sx={{
                  textWrap: "wrap",
                  textAlign: "center",
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                }}
              >
                © {t("Κεντρική Ένωση Επιμελητηρίων Ελλάδος")}{" "}
                {new Date().getFullYear()}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          background: "#1f2937",
          py: 1,
          justifySelf: "flex-end",
          position: "relative",
          mt: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Typography>{t("Σχεδίαση και Ανάπτυξη από την")}</Typography>
          <Link
            rel="noopener"
            target="_blank"
            href="https://www.knowledge.gr/"
            sx={{ color: "#4295ce" }}
          >
            KNOWLEDGE AE
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
